import { all, call, fork, put, select, takeLatest, takeLeading } from "typed-redux-saga";
import { Action, employeeActions } from "./contact-info-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { EmployeeService, Model_EmployeeGet as EmployeeGet, CustomerPortalService } from "src/backend/openapi/v1";
import { hasValue, hasValueAndNotEmpty } from "@itk/typescript-utils";
import { RootState } from "src/store";

export function* getEmployeedetails(action: ReturnType<typeof employeeActions.getEmployeeRequest>) {
  try {
    const result: EmployeeGet = yield call(EmployeeService.getApiV1Employee, action.payload.employeeId);
    yield put(employeeActions.getEmployeeSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
  }
}

export function* watchGetEmployeedetails() {
  yield takeLeading(Action.GetEmployeeRequest, getEmployeedetails);
}

export function* getSalesPerson(action: ReturnType<typeof employeeActions.getCustomerPortalContactRequest>) {
  try {
    const result = yield* call(CustomerPortalService.getApiV1CustomerportalContact, action.payload.customerId);
    if (hasValue(result) && hasValueAndNotEmpty(result.salesPersons)) {
      const employeePicturesCache: Record<string, string> = yield select((state: RootState) => state.pageReducer.employeeInformationReducer.loadingEmployeesPictureCache);
      let employeeIds = result.salesPersons.filter(x => !x.doNotShowPictureInCustomerPortal).map(x => x.employeeId);
      if (hasValueAndNotEmpty(employeeIds)) {
        employeeIds = employeeIds.filter(x => !hasValue(employeePicturesCache[x]));
        if (hasValueAndNotEmpty(employeeIds)) yield put(employeeActions.postCustomerportalEmployeePictureListRequest(employeeIds));
      }
    }

    yield put(employeeActions.getCustomerPortalContactSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(employeeActions.getCustomerPortalContactFail());
  }
}

export function* watchgetSalesPerson() {
  yield takeLeading(Action.GetCustomerPortalContactRequest, getSalesPerson);
}

export function* postCustomerportalEmployeePictureListRequest(action: ReturnType<typeof employeeActions.postCustomerportalEmployeePictureListRequest>) {
  try {
    if (action.payload.employeeIds.length > 0) {
      const result = yield* call(CustomerPortalService.postApiV1CustomerportalEmployeePictureList, undefined, action.payload.employeeIds);
      yield put(employeeActions.postCustomerportalEmployeePictureListSuccess(result));
    }
  } catch (error) {
    yield put(errorActions.addError(error));
    yield put(employeeActions.postCustomerportalEmployeePictureListFail());
  }
}

export function* watchPostCustomerportalEmployeePictureListRequest() {
  yield takeLatest(Action.PostCustomerportalEmployeePictureListRequest, postCustomerportalEmployeePictureListRequest);
}

export function* employeeInformationSaga() {
  yield all([fork(watchGetEmployeedetails), fork(watchgetSalesPerson), fork(watchPostCustomerportalEmployeePictureListRequest)]);
}
